import {getDownloadURL, getStorage, ref, uploadBytesResumable} from 'firebase/storage'
import {useState} from "react";

export const useFirebaseNewsUpload = () => {
    const [uploadProgress, setUploadProgress] = useState(0)

    const uploadFile = ({file, callback, onError}) => {
        if (!file) return;

        // Security bound: limit file size to 10MB to prevent storage exhaustion
        const MAX_FILE_SIZE = 10 * 1024 * 1024;
        if (file.size > MAX_FILE_SIZE) {
            const error = new Error("Filstørrelsen overstiger grensen på 10 MB.");
            console.error(error.message);
            if (onError) onError(error);
            return;
        }

        // Security bound: restrict to image MIME types
        if (file.type && !file.type.startsWith("image/")) {
            const error = new Error("Kun bildefiler er tillatt for opplasting.");
            console.error(error.message);
            if (onError) onError(error);
            return;
        }

        const storage = getStorage()
        const cleanName = file.name ? file.name.replace(/[^a-zA-Z0-9._-]/g, "_") : "bilde.jpg";
        const path = `/news-images/${Date.now()}-${cleanName}`
        const fileRef = ref(storage, path)
        uploadBytesResumable(fileRef, file)
            .on(
                'state_changed',
                snapshot => {
                    setUploadProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
                },
                error => {
                    console.error(error)
                    if (onError) onError(error);
                },
                () => {
                    getDownloadURL(fileRef)
                        .then(url => {
                            setUploadProgress(101)
                            callback(url)
                        })
                        .catch(error => {
                            console.error({error})
                            if (onError) onError(error);
                        })
                }
            )
    }

    return {
        uploadFile,
        uploadProgress
    }
}